<template>
    <v-container grid-list-xs>
        <div>
            <v-row>
                <v-col>
                    <v-sheet class="mt-10 pa-5" elevation="3">
                        <h4 class="mb-2 primary--text">{{ $t("results.decline-header") }}</h4>
                        <p class="mb-5">{{ declineMessage }}</p>
                        <v-row justify="center">
                            <v-col class="text-right mt-6">
                                <SubmitButton class="secondary" @click="finish" rounded>
                                    {{ $t("action.finish") }}
                                </SubmitButton>
                            </v-col>
                        </v-row>
                    </v-sheet>
                </v-col>
            </v-row>
        </div>
    </v-container>
</template>

<script>
    import Providers from "@/model/provider/Providers"
    import { providerState, sessionState } from "@/state"
    import AutoFinishMixin from "@/components/apply/AutoFinishMixin"

    export default {
        mixins: [AutoFinishMixin],
        data() {
            return {
                providerInfo: Providers["aff_standard"],
            }
        },
        computed: {
            declineMessage() {
                const productType = providerState.getPaymentPlans(sessionState.providerKey)[0]?.typeId?.toLowerCase()
                if (productType) {
                    return this.$t(`results.${productType}.decline-message`, { providerName: this.providerInfo.name })
                }
                return this.$t(`results.decline-message`, { providerName: this.providerInfo.name })
            },
        },
    }
</script>
